import _ from 'lodash';
import clientCommon from '../config/client';

let conf = _.cloneDeep(clientCommon);
conf.isProduction = false;

if (process.env.TARGET_SERVER === 'production') {
  conf = _.merge(conf, require('../config/client.prod'));
  conf.isProduction = true;
} else {
  conf = _.merge(conf, require('../config/client.dev'));
}

try {
  conf = _.merge(conf, require('../config/client.local'));
} catch (e) {

}

window.config = _.cloneDeep(conf);



// WEBPACK FOOTER //
// ./src/templates/config.js